var $ce4fef5caa68b83c$exports = {};
$ce4fef5caa68b83c$exports = {
    "valid": `Va\u{17E}e\u{107}e`
};


export {$ce4fef5caa68b83c$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
